/**
 * Guard por **rol**: shell RR.HH. (`/rh/**`). Delega en {@link AuthService.checkRolePermission}
 * con {@link UserRole.rh}.
 *
 * @see AuthService
 */

import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';
import { UserRole } from '../models/auth.model';

export const isRhGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);

  return await authService.checkRolePermission(UserRole.rh);
};
